import { useEffect, useEffectEvent, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LinearProgress } from "@mui/material";

import { useAppDispatch } from "../../state/hooks";
import { loadSessionInfo } from "../../state/actions/authActions";
import { userAccountAjax } from "../../ajax/UserAccountAjax";
import { readSignupRequest } from "./ssoRedirect";

const SignedInArrival: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handled = useRef(false);

  const arrive = useEffectEvent(() => {
    const openApp = () => navigate("/", { replace: true });
    const zoneIds = readSignupRequest(location.search)?.zoneIds ?? [];

    if (zoneIds.length === 0) {
      openApp();
      return;
    }

    userAccountAjax.addDemoZones(zoneIds)
      .then(() => dispatch(loadSessionInfo()))
      .catch(() => false)
      .finally(openApp);
  });

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    arrive();
  }, []);

  return <LinearProgress />;
};

export default SignedInArrival;
